import { Field, FieldArray } from 'formik';
import { Checkbox } from 'formik-material-ui';
import _ from 'lodash';
import React, { useContext } from 'react';
import styled from 'styled-components';
import UsersContext from './UsersContext';

const Container = styled.div`
padding-bottom:10px;
padding-left:20px;
display:flex;
flex-wrap: wrap;
`;

const PermissionItem = styled.em`
    padding-right : 20px
    padding-bottom : 5px;
`;

const FieldLabel = styled.div`
padding-right:20px;
`;

const PermissionFieldContainer = styled.div`
    display:flex;
    align-items:center;
`;

const UserPermissions = ({ formProps }) => {
    const usersContext = useContext(UsersContext);
    const { selectedUserDetails = {} } = usersContext.users;
    const { permissions = [] } = selectedUserDetails;
    if (!usersContext.editingUserDetails) {
        const filteredPermssions = _.filter(permissions, 'hasRole');
        return (
            < Container>
                {filteredPermssions.map((permission, index) => {
                    return (
                        <PermissionItem key={index}>
                            {permission.name}
                        </PermissionItem>
                    )
                })}
            </Container>
        )
    } else {
        return (
            <Container>
                <FieldArray
                    name="permissions"
                    render={arrayHelpers => {
                        return formProps.values.permissions.map((permission, index) => {
                            return (
                                <PermissionFieldContainer key={index}>
                                    <Field
                                        component={Checkbox}
                                        name={`permissions.${index}.hasRole`}
                                        type="checkbox"
                                    />
                                    <FieldLabel>
                                        {permission.name}
                                    </FieldLabel>
                                </PermissionFieldContainer>
                            )
                        })
                    }}
                />
            </Container>
        )
    }
}
export default UserPermissions;